import React from 'react';
import { connect } from 'react-redux';
import { trans } from '../../../localization/language';
import Success from '../../Success';
import { ACCOUNT_SECURITY_BAN_STATUS, UNLOCK_VERIFY_URL } from '../../../constants';

class DoneMobile extends React.Component {
	render() {
		var title = (this.props.userInfo.mobile_no === '') ? trans('bind_mobile_title') : trans('change_mobile_title');
		var message = (this.props.userInfo.mobile_no === '') ? trans('bind_mobile_success') : trans('change_mobile_success');
		return (
			<Success title={title} message={message} redirectTo = {this.props.userInfo.status & ACCOUNT_SECURITY_BAN_STATUS?UNLOCK_VERIFY_URL:'/'}/>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo
	}
}

export default connect(mapStateToProps)(DoneMobile);



// WEBPACK FOOTER //
// ./app/components/security/mobile/DoneMobile.js